<div class="container-fluid">
  <hc-page-heading [description]="'ONBOARDING_REQUESTS.SUBTITLE' | translate">
    {{ 'ONBOARDING_REQUESTS.TITLE' | translate }}
  </hc-page-heading>

  <!-- Stats Cards -->
  <div class="row mb-4">
    <div class="col-md-3">
      <app-stat-card
        icon="clock"
        iconColor="warning"
        [value]="stats.pending"
        [label]="'ONBOARDING_REQUESTS.STATUS.PENDING' | translate">
      </app-stat-card>
    </div>
    <div class="col-md-3">
      <app-stat-card
        icon="phone"
        iconColor="info"
        [value]="stats.contacted"
        [label]="'ONBOARDING_REQUESTS.STATUS.CONTACTED' | translate">
      </app-stat-card>
    </div>
    <div class="col-md-3">
      <app-stat-card
        icon="loader"
        iconColor="primary"
        [value]="stats.in_progress"
        [label]="'ONBOARDING_REQUESTS.STATUS.IN_PROGRESS' | translate">
      </app-stat-card>
    </div>
    <div class="col-md-3">
      <app-stat-card
        icon="list"
        iconColor="secondary"
        [value]="stats.total"
        [label]="'ONBOARDING_REQUESTS.TOTAL' | translate">
      </app-stat-card>
    </div>
  </div>

  <!-- Referral Sources Chart -->
  <div class="card card-v2 mb-4">
    <div class="card-body">
      <h5 class="card-title mb-3">{{ 'ONBOARDING_REQUESTS.REFERRAL_CHART_TITLE' | translate }}</h5>
      @if (referralChartLoading) {
        <div class="d-flex align-items-center justify-content-center py-4 text-muted">
          <span class="spinner-border spinner-border-sm me-2"></span>
          {{ 'common.loading' | translate }}
        </div>
      } @else if (referralChartOptions) {
        <apx-chart
          [series]="referralChartOptions.series"
          [chart]="referralChartOptions.chart"
          [xaxis]="referralChartOptions.xaxis"
          [yaxis]="referralChartOptions.yaxis"
          [dataLabels]="referralChartOptions.dataLabels"
          [plotOptions]="referralChartOptions.plotOptions"
          [legend]="referralChartOptions.legend"
          [tooltip]="referralChartOptions.tooltip"
          [fill]="referralChartOptions.fill"
          [stroke]="referralChartOptions.stroke"
          [colors]="referralChartOptions.colors">
        </apx-chart>
      } @else {
        <div class="text-center text-muted py-4">
          {{ 'ONBOARDING_REQUESTS.NO_REFERRAL_DATA' | translate }}
        </div>
      }
    </div>
  </div>

  <!-- Main Card -->
  <div class="card card-v2">
    <div class="card-body">
      <!-- Status Tabs -->
      <div class="tabs-v2 mb-3">
        @for (option of statusOptions; track option.value) {
          <button
            class="tab-item"
            [class.active]="statusFilter === option.value"
            (click)="onStatusFilterChange(option.value)">
            {{ option.label | translate }}
            @if (option.value === 'pending' && stats.pending > 0) {
              <hc-badge color="primary" size="small" variant="heavy" class="ms-1">{{ stats.pending }}</hc-badge>
            }
          </button>
        }
      </div>

      <!-- Cell Templates -->
      <ng-template #hotelCell let-row>
        <div class="fw-medium">{{ row.hotel_name }}</div>
        <small class="text-muted">
          {{ row.hotel_city }}
          @if (row.hotel_country) {
            <span>, {{ row.hotel_country }}</span>
          }
        </small>
      </ng-template>

      <ng-template #contactCell let-row>
        <div>{{ row.contact_name }}</div>
        <small class="text-muted">{{ row.contact_email }}</small>
      </ng-template>

      <ng-template #dateCell let-row>
        {{ row.created_at | date:'dd.MM.yyyy' }}
      </ng-template>

      <ng-template #statusCell let-row>
        <hc-badge [color]="getStatusVariant(row.status)" variant="light" size="small">
          {{ 'ONBOARDING_REQUESTS.STATUS.' + row.status.toUpperCase() | translate }}
        </hc-badge>
      </ng-template>

      <ng-template #actionsCell let-row>
        <hc-button variant="secondary" leftIcon="eye" (clicked)="navigateToDetail(row)">
          {{ 'COMMON.VIEW' | translate }}
        </hc-button>
      </ng-template>

      <!-- Data Table -->
      <app-data-table
        [data]="requests"
        [columns]="tableColumns"
        trackByKey="id"
        [loading]="isLoading"
        [rowClickable]="true"
        [paginated]="true"
        [page]="currentPage"
        [pageSize]="pageSize"
        [total]="totalItems"
        [pageSizeOptions]="[10, 15, 25, 50]"
        emptyTitle="ONBOARDING_REQUESTS.NO_REQUESTS"
        emptyDescription=""
        emptyIcon="inbox"
        (rowClick)="navigateToDetail($event.row)"
        (pageChange)="onPageChange($event)">
      </app-data-table>
    </div>
  </div>
</div>
